import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { getBlogPostBySlug, BlogPost } from '../data/blogData'
import './BlogPost.css'

const BlogPost: React.FC = () => {
  const { slug } = useParams<{ slug: string }>()
  const [post, setPost] = useState<BlogPost | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadPost = async () => {
      if (!slug) {
        setLoading(false)
        return
      }

      try {
        const blogPost = await getBlogPostBySlug(slug)
        console.log('Slug:', slug, 'Post:', blogPost)
        setPost(blogPost)
      } catch (error) {
        console.error('Error loading blog post:', error)
      } finally {
        setLoading(false)
      }
    }

    loadPost()
  }, [slug])

  if (loading) {
    return (
      <div className="blog-post-container">
        <div className="blog-loading">
          <p>Loading post...</p>
        </div>
      </div>
    )
  }

  if (!post) {
    return (
      <div className="blog-post-container">
        <div className="blog-not-found">
          <h1>Post not found</h1>
          <p>The blog post you're looking for doesn't exist.</p>
          <Link to="/blog" className="blog-back-link">
            ← Back to blog
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="blog-post-container">
      <nav className="blog-nav">
        <Link to="/blog" className="blog-back-link">
          ← Back to blog
        </Link>
      </nav>

      <article className="blog-post">
        <header className="blog-post-header">
          <h1 className="blog-post-title">{post.title}</h1>

          <div className="blog-post-meta">
            <time dateTime={post.date} className="blog-post-date">
              {new Date(post.date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </time>
            {post.readTime && (
              <span className="blog-post-read-time">• {post.readTime}</span>
            )}
          </div>

          {post.tags && post.tags.length > 0 && (
            <div className="blog-post-tags">
              {post.tags.map((tag) => (
                <span key={tag} className="blog-tag">
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </header>

        <div
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </article>

      <footer className="blog-post-footer">
        <Link to="/blog" className="blog-back-link">
          ← Back to all posts
        </Link>
      </footer>
    </div>
  )
}

export default BlogPost